import React from "react";

import MarkedDay from "components/Tvendo/Mobile/MarkedDay";

export default function () {
  return <MarkedDay />;
}
